import { defineMessages } from 'react-intl';

export default defineMessages({
  branchesSeparator: {
    id: 'frontbucket.repository.pullRequest.branchesAndState',
    description: 'Label displayed between branches in the header',
    defaultMessage: 'To',
  },
});
